import { Action, createReducer, on } from "@ngrx/store";
import { EditorActions } from "./editor.actions";
import { ContentAndModelId } from "../types/editor-types";

export const STORE_FEATURE_KEY_EDITOR_TEMPLATE = "editorTemplate";

export interface EditorTemplateState {
  past: ContentAndModelId[];
  present: ContentAndModelId | null;
  future: ContentAndModelId[];
  windowSelectionTimestamp: number;
}

export const initializeEditorTemplateState: EditorTemplateState = {
  past: [],
  present: null,
  future: [],
  windowSelectionTimestamp: 0
};

const reducer = createReducer(
  initializeEditorTemplateState,
  on(EditorActions.resetHistory, (state, payload) => ({
    ...state,
    past: [],
    present: null,
    future: [],
  })),
  on(EditorActions.undoChange, (state) => ({
    ...state,
    past: state.past.slice(0, state.past.length - 1),
    present: state.past.slice(-1)[0],
    future: [...state.future, state.present],
  })),
  on(EditorActions.redoChange, (state) => ({
    ...state,
    past: [...state.past, state.present],
    present: state.future.slice(-1)[0],
    future: state.future.slice(0, state.future.length - 1),
  })),
  on(
    EditorActions.updateHistory,
    (state, { previousValue, currentValue, updateModelVariable }) => ({
      ...state,
      past: [...state.past, { [updateModelVariable]: previousValue }],
      present: { [updateModelVariable]: currentValue },
    })
  ),
  on(
    EditorActions.updateHistoryForDifferentVariable,
    (state, { previousValue, currentValue, updateModelVariable }) => ({
      ...state,
      past: [
        ...state.past,
        { ...state.present, [updateModelVariable]: previousValue },
      ],
      present: { [updateModelVariable]: currentValue },
    })
  ),
  on(
    EditorActions.updateWindowSelectionTimestamp,
    (state, { timestamp }) => ({
      ...state,
      windowSelectionTimestamp: timestamp
    })
  ),
  on(
    EditorActions.resetWindowSelectionCounter,
    (state) => ({
      ...state,
      windowSelectionTimestamp: 0
    })
  )
);

export function EditorTemplateReducer(
  state: EditorTemplateState | undefined,
  action: Action
): EditorTemplateState {
  return reducer(state, action);
}
